import React, { useEffect, useRef } from "react";
import "./BusinessThreeTestimonials.scss";

const testimonials = [
  {
    icon: "https://w0.peakpx.com/wallpaper/107/46/HD-wallpaper-best-pose-for-profile-for-men-profile-pose-men-best-glasses.jpg",
    heading: "Top-Quality Linen for Your Business",
    description:
      "Discover how Megha Linen and Workwear delivers premium quality your business's image and efficiency.",
  },
  {
    icon: "https://hrcenter.com.gt/wp-content/uploads/2019/09/coach1.jpg",
    heading: "Reliable Workwear Solutions",
    description:
      "Our workwear solutions are designed to provide durability and comfort.",
  },
  {
    icon: "https://zoneweymouth.com/wp-content/uploads/2018/01/quote-2-zone-weymouth-600x600.jpeg",
    heading: "Seamless Laundry Services",
    description:
      "Experience hassle-free laundry services with Megha Linen and Workwear, making sure your linens and workwear.",
  },
  {
    icon: "https://th.bing.com/th/id/OIP.K86XD8erZ9qA1dDbuRGsDwHaHu?w=1238&h=1291&rs=1&pid=ImgDetMain",
    heading: "Custom Workwear for Every Industry",
    description:
      "Our custom workwear options cater to various industries, providing tailored solutions.",
  },
  {
    icon: "https://sm.askmen.com/t/askmen_in/article/f/facebook-p/facebook-profile-picture-affects-chances-of-gettin_fr3n.1200.jpg",
    heading: "Eco-Friendly Linen Solutions",
    description:
      "We offer eco-friendly linen options that are both sustainable maintaining quality.",
  },
  {
    icon: "https://hfmglobal.ae/wp-content/uploads/2024/02/pic-11-1.jpg",
    heading: "Affordable Quality",
    description:
      "At Megha Linen and Workwear, we provide top-notch quality investment.",
  },
  {
    icon: "https://th.bing.com/th/id/OIP.65vAE_Vwi_IlQL5N8dGI3AHaGW?w=700&h=600&rs=1&pid=ImgDetMain",
    heading: "Superior Customer Service",
    description: "Our dedicated customer service team is here to assist you.",
  },
  {
    icon: "https://cdn.prod.website-files.com/65f82769357f2cd4f6b6e20e/65fc86e9cd8025cc6ca5893b_talent_photo_5.jpg",
    heading: "Innovative Laundry Solutions",
    description:
      "We continually innovate to provide cutting-edge laundry solutions that meet the reliability.",
  },
];

const BusinessThreeTestimonials = ({ id }) => {
  const headingRef = useRef(null);

  // CODE START FOR ANIMATION HEADING
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate");
          } else {
            entry.target.classList.remove("animate");
          }
        });
      },
      { threshold: 0.1 }
    );

    if (headingRef.current) {
      observer.observe(headingRef.current);
    }

    return () => {
      if (headingRef.current) {
        observer.unobserve(headingRef.current);
      }
    };
  }, []);
  // CODE END FOR ANIMATION HEADING
  return (
    <div
      className="business-three-testimonials-section-parent"
      style={{ backgroundColor: "var(--white-color)" }}
      id={id}
    >
      <div className="small_padding_div"></div>

      <div className="large_padding_div"></div>
      <div className="business-three-testimonials-section container">
        <div className="container business-three-box-container">
          <div ref={headingRef} className="business-three-heading-div">
            <h3>
              Hear From Our <span>Satisfied Customers</span>
            </h3>
          </div>
          <div className="business-three-template-view-more-icon">
            <span class="material-symbols-outlined">arrow_forward_ios</span>{" "}
          </div>
        </div>
        <div className="large_padding_div"></div>
        <div className="row">
          <div className="col-12 col-md-5">
            <div className="row business-three-testimonials-section-row">
              <div className="col-6">
                {testimonials.slice(0, 2).map((testimonial, index) => (
                  <div
                    key={index}
                    className="business-three-testimonials-testimonial-card"
                  >
                    <div className="d-flex align-items-center gap-2">
                      <img
                        src={testimonial.icon}
                        alt="Icon"
                        className="business-three-testimonials-icon"
                      />
                      <h3>{testimonial.heading}</h3>
                    </div>
                    <p>{testimonial.description}</p>
                  </div>
                ))}
              </div>

              <div className="col-6">
                {testimonials.slice(2, 4).map((testimonial, index) => (
                  <div
                    key={index}
                    className="business-three-testimonials-testimonial-card"
                  >
                    <div className="d-flex align-items-center gap-2">
                      <img
                        src={testimonial.icon}
                        alt="Icon"
                        className="business-three-testimonials-icon"
                      />
                      <h3>{testimonial.heading}</h3>
                    </div>
                    <p>{testimonial.description}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="col-12 col-md-2 d-flex">
            <div className="business-three-testimonials-background-circle">
              <img src="data:image/png;base64,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" />
            </div>
            <div className="business-three-testimonials-circle-wrapper">
              <div className="business-three-testimonials-background-circle-1"></div>
              <div className="business-three-testimonials-background-circle-2"></div>
              <div className="business-three-testimonials-center-circle">
                Testimonials
              </div>
            </div>
          </div>

          <div className="col-12 col-md-5">
            <div className="row business-three-testimonials-section-row business-three-testimonials-section-row-phone">
              <div className="col-6">
                {testimonials.slice(4, 6).map((testimonial, index) => (
                  <div
                    key={index}
                    className="business-three-testimonials-testimonial-card"
                  >
                    <div className="d-flex align-items-center gap-2">
                      <img
                        src={testimonial.icon}
                        alt="Icon"
                        className="business-three-testimonials-icon"
                      />
                      <h3>{testimonial.heading}</h3>
                    </div>
                    <p>{testimonial.description}</p>
                  </div>
                ))}
              </div>
              <div className="col-6">
                {testimonials.slice(6, 8).map((testimonial, index) => (
                  <div
                    key={index}
                    className="business-three-testimonials-testimonial-card"
                  >
                    <div className="d-flex align-items-center gap-2">
                      <img
                        src={testimonial.icon}
                        alt="Icon"
                        className="business-three-testimonials-icon"
                      />
                      <h3>{testimonial.heading}</h3>
                    </div>
                    <p>{testimonial.description}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="large_padding_div"></div>
    </div>
  );
};

export default BusinessThreeTestimonials;
